"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleImages = void 0;
exports.vehicleImages = {
    Citroen: [
        {
            url: 'https://media.citroen.no/design/frontend/images/illustrations/Dimensions/B2C/1CE3A5/1.png',
        },
        {
            url: 'https://visuel3d-secure.citroen.com/V3DImage.ashx?client=CFGAP3D&ratio=1&format=jpg&quality=90&version=1CB6A5NNMJC0A030&color=0MP00NWP&trim=0P230RFR&opt1=ZH57&opt2=WLO2&width=1280',
        },
    ],
    DS: [
        {
            url: 'https://mediapays-cdn-dspp-driveds.dsautomobiles.com/image/04/9/.61049.252.jpg',
        },
        {
            url: 'https://mediapays-cdn-dspp-driveds.dsautomobiles.com/image/05/1/.61051.252.jpg',
        },
        {
            url: 'https://mediapays-cdn-dspp-driveds.dsautomobiles.com/image/01/1/.76011.252.jpg',
        },
    ],
    Kia: [
        {
            url: 'https://www.kia.com/content/dam/kwcms/kme/global/en/assets/vehicles/e-niro/discover/kia-niro-de-ev-my19-the-new-kia-w.jpg',
        },
        {
            url: 'https://www.kia.com/content/dam/kwcms/kme/global/en/assets/360vr/e-niro/ABT-platinum-graphite/17AlloyWheel/kia-niro-deevmy19-abtplatinumgraphite-17_0000.jpg',
        },
        {
            url: 'https://www.kia.com/content/dam/kwcms/kme/global/en/assets/vehicles/sportage/discover/kia_sportage_ql_pe_my19_discover-w.jpg',
        },
        {
            url: 'https://www.kia.com/content/dam/kwcms/kme/global/en/assets/360vr/sorento/ABT-platinum-graphite/19Alloy/kia-sorento-umpemy18-abtplatiniumgraphite-19d_0000.jpg',
        },
        {
            url: 'https://www.kia.com/content/dam/kwcms/kme/global/en/assets/vehicles/sorento/discover/kia-sorento-comfort_w.jpg',
        },
    ],
    Mercedes: [
        {
            url: 'https://kampanje.mercedes-benz.no/wp-content/uploads/2019/07/1200x385_C-Klasse_pih4.jpg',
        },
        {
            url: 'https://kampanje.mercedes-benz.no/wp-content/uploads/2019/07/1200x385_C-Klasse_pih1.jpg',
        },
        {
            url: 'https://kampanje.mercedes-benz.no/wp-content/uploads/2017/05/1200x385_C-Klasse_sedan_2.jpg',
        },
        {
            url: 'https://kampanje.mercedes-benz.no/wp-content/uploads/2017/05/1200x385_C-Klasse_sedan_4.jpg',
        },
        {
            url: 'https://kampanje.mercedes-benz.no/wp-content/uploads/2017/05/1200x385_C-Klasse_sedan_3.jpg',
        },
    ],
    Opel: [
        {
            url: 'https://www.opel.no/content/dam/opel/norway/home-page/21x9/NO-Ampera-e-home-21x9.jpg?imwidth=1284',
        },
        {
            url: 'https://www.opel.no/content/dam/opel/master/vehicles/Grandland-X/my_2000_phev/21x9/opel_grandland_x_hybrid4_exterior_21x9_gr20_e01_227.jpg?imwidth=1284',
        },
        {
            url: 'https://www.opel.no/content/dam/opel/master/vehicles/corsa-f/16x9/opel_corsa_exterior_16x9_BIgtx20_e01_007_C_016611.jpg?imwidth=600',
        },
    ],
    Peugeot: [
        {
            url: 'https://kampanje.peugeot.no/web/bcmresource/___ww7YrRVwSdO_2DKDcziyJA!!/media/resources/templates/peugeot/public/img/model/suv5008/5008%20range.png',
        },
        {
            url: 'https://kampanje.peugeot.no/web/bcmresource/___-qBcbtkTRb6Ie2P9QXxztg!!/media/resources/templates/peugeot/public/img/model/hybrid-3008/3008-Hybrid.png',
        },
    ],
    Smart: [
        {
            url: 'https://kampanje.mercedes-benz.no/wp-content/uploads/2018/04/1200x385_smart_EQ-4.jpg',
        },
        {
            url: 'https://kampanje.mercedes-benz.no/wp-content/uploads/2018/04/1200x385_smart_EQ-5.jpg',
        },
    ],
};
//# sourceMappingURL=vehicle-images.js.map